import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import NavBar from "./components/ui/Navbar.js";
import HomePage from "./components/HomePage.js";
import BuisnessAssociates from "./components/BuisnessAssociates.js";
import AboutUs from "./components/AboutUs.js";
import Footer from "./components/ui/Footer.js";
import ContactUs from "./components/ContactUs.js";
import ServicesKoha from "./components/ServicesKoha.js";
import ServicesMobileApp from "./components/ServicesMobileApp.js";
import TopBar from "./components/ui/TopNav.js";
import RedirectService from "./components/ui/Services.js";
import Faqs from "./components/ui/Faqs.js";
import ErrorPage from "./components/ui/ErrorPage.js";
import Loader from "./components/ui/Loader.js";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);


  return (
    <Router>
      {loading && (
        <Loader />
      )}
      {!loading && (
        <>
          <RedirectService />
          <TopBar />
          <NavBar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/business-associates" element={<BuisnessAssociates />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/services/services-koha" element={<ServicesKoha />} />
            <Route path="/services/mobile-app" element={<ServicesMobileApp />} />
            <Route
              path="/faqs"
              element={<div className="sizedbox text-center py-5"><Faqs /></div>}
            />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <Footer />
        </>
      )}
    </Router>
  );
}

export default App;
